import { useEffect, useState } from "react";
import styled from "styled-components";
import Backdrop from "components/global/Backdrop";
import WarningIconTriangle from "icons/WarningIconTriangle";
import { connect } from "react-redux";
import Button from "components/global/Button";
import Spacer from "components/global/Spacer";
import VerifyOtpModal from "./VerifyOtpModal";
import { resendVerificationEmail } from "api";
import { useMutation } from "@tanstack/react-query";
import { showAlert } from "utils/utils";

const Wrapper = styled(Backdrop)`
  .modal {
    width: 480px;
    background: #fff;
    padding: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 24px;
    border-radius: 8px;
  }
`;

const VerifyEmailPrompt = ({ user }) => {
  const [showModal, setShowModal] = useState(null);
  const [showOtpModal, setShowOtpModal] = useState(false);

  const { mutate: sendVerificationCode, isPending } = useMutation({
    mutationFn: () => resendVerificationEmail({ email: user.email }),
    onSuccess: () => {
      setShowModal(false);
      setShowOtpModal(true);
    },
    onError: (error) => {
      showAlert({
        msg: error.message ?? "An error occurred",
        type: "danger",
      });
    },
  });

  useEffect(() => {
    if (user.email_verified_at) {
      setShowModal(false);
      return;
    }

    const showVerifyEmailPrompt = sessionStorage.getItem(
      "showVerifyEmailPrompt"
    );
    if (!showVerifyEmailPrompt) {
      setShowModal(true);
    }
  }, [user.email_verified_at]);

  if (!showModal || user.email_verified_at) {
    return null;
  }

  return (
    <Wrapper className="show flexRow alignCenter justifyCenter">
      <div className="modal">
        <WarningIconTriangle size={25} />
        <h4>Verify your email address</h4>

        <p className="colorGrey6 textCenter">
          Verify your email address to unlock full access and continue using
          PostPaddy without interruptions.
        </p>

        <div className="fullWidth flexRow alignCenter">
          <Button
            text="Cancel"
            className="borderedGrey l3"
            height="40px"
            width="100%"
            onClick={() => {
              setShowModal(false);
              sessionStorage.setItem("showVerifyEmailPrompt", "true");
            }}
            disabled={isPending}
          />
          <Spacer x={2} />
          <Button
            text="Verify email"
            className="l3"
            height="40px"
            width="100%"
            onClick={() => {
              sendVerificationCode();
              sessionStorage.setItem("showVerifyEmailPrompt", "true");
            }}
            disabled={isPending}
            loading={isPending}
          />
        </div>
      </div>

      {showOtpModal && (
        <VerifyOtpModal user={user} setShowModal={setShowOtpModal} />
      )}
    </Wrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

export default connect(mapStateToProps)(VerifyEmailPrompt);
